import React, { useState, useContext, useRef, useEffect } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FiMenu, FiPhone } from "react-icons/fi";
import { BiSearch } from "react-icons/bi";
import { AiOutlineUser, AiOutlineShoppingCart } from "react-icons/ai";
import Row from "react-bootstrap/Row";
import logo from "../../../assets/images/logo/ChatGPT Image Nov 17, 2025, 04_11_35 PM.png";
import SearchDrawer from "../MobileHeader/SearchDrawer";
import MenuDrawer from "./MenuDrawer";
import Container from "../../LogIn/Container";
import "./mobileHeader.scss";
import WithAuthentication from "context/Authentication/AuthenticationContext.ts";
import CardItemContext from "context/CardItem/CardItemContext";
import Basket from "../Header/Basket";
import useAxios from "services/useAxios.tsx";
import { debounce } from "lodash";
import { NavLink } from "react-router-dom";

const MobileHeader = () => {
  const { execute: searchApi } = useAxios("api3/search");

  const { setShowOffcanvas, itemCount } = useContext(CardItemContext);
  const [showSearch, setShowSearch] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [loginShow, setLoginShow] = useState(false);
  const { isLogged } = useContext(WithAuthentication);

  const [searchQuery, setSearchQuery] = useState("");
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [articles, setArticles] = useState([]);

  const callApiSearch = (query) => {
    const data = { title: query, page: 1, count: 6 };
    if (query !== "") {
      searchApi(data).then((res) => {
        setProducts(res.products.slice(0, 10));
        setCategories(res.hashtags.slice(0, 10));
        setArticles(res.post.slice(0, 10));
      });
    }
  };

  const searchDebounce = useRef(
    debounce((text) => {
      callApiSearch(text);
    }, 1200)
  );

  useEffect(() => {
    callApiSearch("");
  }, []);

  return (
    <div className="mobile_header">
      <div className="mobile_topbar">
        <span>تهران، بلوار دامپزشک</span>
        <a href="tel:02112345678">۰۲۱-۱۲۳۴۵۶۷۸</a>
      </div>
      <div className="mobile_nav">
        <button
          className="icon-button"
          aria-label="منوی اصلی"
          onClick={() => setShowMenu(true)}
        >
          <FiMenu size={26} />
        </button>
        <NavLink to="/" className="text-decoration-none mobile_brand">
          <img src={logo} alt="پت مدیک" />
          <div>
            <span>پت مدیک</span>
            <small>پت‌شاپ + بیمارستان</small>
          </div>
        </NavLink>
        <div className="mobile_actions">
          <button
            className="icon-button"
            onClick={() =>
              document
                .getElementById("footer-container")
                ?.scrollIntoView({ behavior: "smooth", block: "nearest" })
            }
          >
            <FiPhone size={22} />
          </button>
          <button
            className="icon-button"
            onClick={() =>
              isLogged
                ? (window.location.href = "/customer-panel/profile")
                : setLoginShow(true)
            }
          >
            <AiOutlineUser size={24} />
          </button>
          <button
            className="icon-button"
            onClick={() => setShowOffcanvas((prev) => !prev)}
          >
            <AiOutlineShoppingCart size={24} />
            {itemCount > 0 && <span className="badge">{itemCount}</span>}
          </button>
        </div>
      </div>
      <div className="mobile_search">
        <Row className="align-items-center w-100">
          <div className="w-100">
            <div className="mobile_search-box" onClick={() => setShowSearch(true)}>
              <BiSearch size={17} className="mobile_search-icon" />
              <input
                type="search"
                placeholder="جستجو در پت مدیک"
                className="mobile_search-input"
                readOnly
              />
            </div>
            <Offcanvas
              show={showSearch}
              placement="bottom"
              onHide={() => setShowSearch(false)}
              backdrop="static"
              className="drawer_box"
            >
              <Offcanvas.Body>
                <SearchDrawer
                  close={() => setShowSearch(false)}
                  searchDebounce={searchDebounce}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                  products={products}
                  categories={categories}
                  articles={articles}
                />
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </Row>
      </div>
      <Offcanvas
        show={showMenu}
        onHide={() => setShowMenu(false)}
        placement="start"
        className="menu_drawer"
      >
        <Offcanvas.Body className="humberger_menu-drawer">
          <MenuDrawer setShowMenu={setShowMenu} />
        </Offcanvas.Body>
      </Offcanvas>
      <Container loginShow={loginShow} setLoginShow={setLoginShow} />
      <Basket />
    </div>
  );
};

export default MobileHeader;
